/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
export const ActionTypes = {
  START_PAYPAL: 'START_PAYPAL',
  SUCCESS_PAYPAL: 'SUCCESS_PAYPAL',
  ERROR_PAYPAL: 'ERROR_PAYPAL'
};

/**
 * Creates an action for the state of a PayPal API request.
 *
 * @return {{type: string}}
 */
export function startPayPal() {
  return {
    type: ActionTypes.START_PAYPAL
  };
}

/**
 * Creates an action for a successful response from a PayPal API.
 *
 * @param {Object} data - The response from the API
 * @return {{payload: {data: Object, receivedAt: number}, type: string}}
 */
export function successPayPal(data) {
  return {
    type: ActionTypes.SUCCESS_PAYPAL,
    payload: {
      data,
      receivedAt: Date.now()
    }
  };
}

/**
 * Creates an action for an error response from the PayPal API.
 *
 * @param {ErrorType} error - The error that occurred
 * @return {{payload: *, type: string}}
 */
export function errorPayPal(error) {
  return {
    type: ActionTypes.ERROR_PAYPAL,
    payload: error
  };
}
